export default __webpack_public_path__ + "static/media/PotProKit_PickYourOwn_8in_8_main.b03771db.png";